import React from 'react';
import './AlertPermissionBox.scss';
import {InfoTriangle} from "../../../../image";
import {Text} from "../../../../modules";
import {useTranslation} from "react-i18next";

const AlertPermissionBox = () => {
    const {t} = useTranslation();

    return (
        <div className="alert-permission">
            <InfoTriangle/>
            <div className="alert-permission--text">
                <Text size="f14">
                    {t('alert_permission_box_text_1')}
                    <Text font="bold" size="f14">{t('alert_permission_box_text_2')}</Text>
                    {t('alert_permission_box_text_3')}

                </Text>
            </div>
        </div>
    );
};

export default AlertPermissionBox;